export default {
	apiBaseUrl: 'https://my-dev.cybservices.co.uk/bpiInt3',
	apiBaseUrlPAAS: 'https://int3-api-ib-np.cybservices.co.uk',
	apiBankId: null, // This will be set after calling get user
	brandId: (process.env.BRAND_ID || 'vm').toUpperCase(),
	isSavingsPotsEnabled: false,
	isSpendingsEnabled: false,
	isTaggingEnabled: false,
	isFinancialStoryEnabled: false,
	isContactDetailsEnabled: true,
	isHelpDemoEnabled: false,
	isSweepsEnabled: false,
	isNBAEnabled: true,
	isNicknameAmendEnabled: true,
	callValidate3DTimelimit: 300000,
	disableAnalytics: true,
	trackingId: 'f3b083deb956a224b0bc2c7545973fbf9e53a7be',
	disableNavigationWarning: true,
	enableWindowStubs: true,
	stubApiData: false,
	isSecureMessageEnabled: true,
	targetScope: {
		unknown: -1,
		notAuthed: 0,
		authentication: 30,
		login: 20,
	},
	websiteBaseDirectory: '/',

	// Timers
	autoLoginTimeout: 5000, // How long after registering a user for the first time should we wait before logging them in?
	nextTaskCheckInterval: 5000, // How often should a loading page call getNextTask after the last call?
	defaultAutoSaveInterval: 600000, // How often should the form be automatically saved for a user?
	shortAutoSaveInterval: 600000, // After an error occurs, how long before we try an autosave again?
	publicKeyExpiry: 29000, // How long do public keys from RAM last before becoming invalid?
	tokenInactivityTimeout: 600000, // How long to wait after a user's last action before expiring their session?
	statementsURl: 'https://apps-np.cybonline.co.uk/int3/statements/index.html',
	idvRedirectURL:
		'https://apps-np.cybonline.co.uk/int3/authenticate/cb?client_id=local&response_type=token&state={state}&redirect_uri=http%3A%2F%2Flocalhost%3A3000&scope=30',
	redirectToBOW:
		'http://localhost:3000/bapp/authentication&response_type=token&client_id=cb_web#access_token={access_token}',
	manageContactDetailsLink:
		'https://apps-np.cybonline.co.uk/int3/customer-details/#access_token={access_token}&state={state}&user_tracking_id={user_tracking_id}&brand_id=CB&show=CD&expand=CD&bank_id={bank_id}&redirect_uri={redirect_uri}',
	marketingPreferenceLink:
		'https://apps-np.cybonline.co.uk/int3/customer-details/#access_token={access_token}&state={state}&bank_id={bank_id}&show=MC&expand=MC&redirect_uri={redirect_uri}&user_tracking_id={user_tracking_id}&brand_id=CB',
	manageCredentialLink:
		'https://apps-np.cybonline.co.uk/int3/authenticate/cb/amend?redirect_uri=http%3A%2F%2Flocalhost%3A3000/bapp/authentication&response_type=token&state={state}&client_id=cb_web#access_token={access_token}&user_tracking_id={user_tracking_id}',
	malwareurl: '273.n.trusteer.com/8890311',
	eGainLiveServerURL: 'https://cybgdev.egain.cloud/system',
	coBrowseScriptID: 'EG30181642',
	domainName: 'cb.dybapplications.co.uk',
	secureMessageURL:
		'https://apps-np.cybonline.co.uk/int3/secure-messaging/securemessages/{brandId}/#access_token={access_token}&bank_id={bank_id}&client_context={client_context}&user_tracking_id={user_tracking_id}&brandId={brandId}',
	fileUpload: {
		beneficiary: {
			faq: 'https://www.ybonline.co.uk/business/uploads/Beneficiary',
			template: 'https://www.ybonline.co.uk/business/uploads/Beneficiary',
			isFeatureEnabled: true,
			maxRecords: 1000,
		},
		bacsCredit: {
			faq: 'https://www.ybonline.co.uk/business/uploads/BACSCredit',
			template: 'https://www.ybonline.co.uk/business/uploads/BACSCredit',
			isFeatureEnabled: true,
			maxRecords: 750,
		},
		bacsDebit: {
			faq: 'https://www.ybonline.co.uk/business/uploads/BACSDebit',
			template: 'https://www.ybonline.co.uk/business/uploads/BACSDebit',
			isFeatureEnabled: true,
			maxRecords: 750,
		},
		fps: {
			faq: 'https://www.ybonline.co.uk/business/uploads/FPS',
			template: 'https://www.ybonline.co.uk/business/uploads/FPS',
			isFeatureEnabled: true,
			maxRecords: 750,
		},
		chaps: {
			faq: 'https://www.ybonline.co.uk/business/uploads/CHAPS',
			template: 'https://www.ybonline.co.uk/business/uploads/CHAPS',
			isFeatureEnabled: true,
			maxRecords: 750,
		},
		chunks: {
			maxThreads: 2,
			maxItemsPerChunk: {
				beneficiary: 150,
				fps: 100,
				chaps: 100,
				scheduledPayments: 4,
			},
		},
	},
	envTags: "[u'nonprod', u'local']",
	chapsPaymentLimit: 150,
	staticContentWebAppLink: 'https://static-content.int3ib.apps.virginmoney.com',
};
